class StorageService {
  constructor() {
    this.localStorage = localStorage;
    this.sessionStorage = sessionStorage;
  }

  getFavorites() {
    const favorites = this.localStorage.getItem('bosanoga-favorites');

    return favorites ? JSON.parse(favorites) : [];
  }

  setFavorites(favorites) {
    this.localStorage.setItem('bosanoga-favorites', JSON.stringify(favorites))
  }

  getViewed() {
    const viewed = this.sessionStorage.getItem('bosanoga-viewed');

    return viewed ? JSON.parse(viewed) : [];
  }

  setViewed(viewed) {
    this.sessionStorage.setItem('bosanoga-viewed', JSON.stringify(viewed))
  }
}

export default StorageService
